export default __webpack_public_path__ + "static/media/application-banner-img-02.3720409c.jpg";